import React from 'react'
import { Alert, AlertDescription, Box } from '@chakra-ui/react'
import parse from 'html-react-parser'
import 'react-quill/dist/quill.snow.css'

interface PurpleBubbleContentProps {
  text: string
}

const PurpleBubbleContent: React.FC<PurpleBubbleContentProps> = ({ text }) => {
  return (
    <Alert
      status="info"
      size="sm"
      rounded="md"
      backgroundColor="purple.100"
      variant="subtle"
    >
      <AlertDescription fontSize="sm">
        <Box className="ql-editor">{parse(text)}</Box>
      </AlertDescription>
    </Alert>
  )
}

export default PurpleBubbleContent
